var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRatingStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2416 5.47408C16.2073 5.37627 16.1162 5.30494 16.0065 5.29008L10.7428 4.57974L8.38876 0.150767C8.33988 0.0583614 8.23862 0 8.12804 0C8.01747 0 7.91592 0.0583614 7.86733 0.150767L5.51305 4.58002L0.249302 5.29035C0.139605 5.30521 0.0488203 5.37627 0.0141942 5.47435C-0.0198499 5.57189 0.00837469 5.67942 0.087811 5.75103L3.89697 9.19867L2.99757 14.067C2.97894 14.1683 3.02375 14.2707 3.11308 14.3312C3.20299 14.3923 3.322 14.4001 3.41948 14.3518L8.12804 12.0535L12.836 14.3518C12.8785 14.3726 12.9254 14.3828 12.9716 14.3828C13.0319 14.3828 13.0918 14.3655 13.1427 14.3312C13.2323 14.2707 13.2771 14.1683 13.2582 14.067L12.3591 9.19894L16.1683 5.75103C16.2474 5.67888 16.2759 5.57162 16.2416 5.47408Z",
    fill: "url(#paint0_linear_409_17192)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_409_17192",
    x1: 15.4998,
    y1: 6.32153,
    x2: 1.49982,
    y2: 6.82153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFBB02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB02"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStar);
export default __webpack_public_path__ + "static/media/RatingStar.0bc1dcaf5c2b2f82c8c9c313f2c58b0e.svg";
export { ForwardRef as ReactComponent };